const trans = {
  Profile: "الملف الشخصي",
  "Receive email updates on new orders": "استلام ايميلات عند وصول طلبات جديدة",
  "Receive email updates on feedbacks": "استلام ايميلات عند وصول تعليقات جديدة",
  "To access your dashboard, please verify your email and phone number. Need help?":
    "لاستخدام شاشة تحكمك، يرجى توثيق الايميل ورقم الهاتف. تحتاج مساعدة؟",
  "Chat with us": "تواصل معنا",
  "Receive email updates on new business orders":
    "استلام اميلات عند وصول طلبات شركات جديد",

  Pin: "الرمز",
  "Wrong Pin": "الرمز غير صحيح",
};

export default trans;
